<template>
  <EditCom
    :title="title"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';

import EditCom from '@/components/EditCom';

import {
  loadUserWorkspaceData,
} from '@/api/UserWorkspaceApi';

import {
  queryAirTypeList,
} from '@/api/DictApi';

// props
const props = defineProps({
  title: { type: String, },
  target: { type: Object, },
  workSpace: { type: Object, },
  AirAndWarshipList: { type: Array, },
});
// emit
const emit = defineEmits([
  'close', 'submitCallback',
]);

const close = ()=>{
  emit('close');
}

const dataTypeList = [
  { id: 1, label: '全球曝光', },
  // { id: 2, label: '轨迹数据', },
  { id: 6, label: '轨迹数据', },
  { id: 3, label: 'NOTAM', },
  { id: 4, label: 'NTM', },
  { id: 5, label: 'TFR', },
];
const target = reactive({
  ...props.target,
  dataTypeList: dataTypeList,
  trackTypeList: props.AirAndWarshipList,
});

const submitFn = (item, button, loadFn, fn)=>{
  // console.log(item);
  loadUserWorkspaceData({
    ...item,
    startTime: dayjs(item['startTime']).format('YYYY-MM-DD'),
    endTime: dayjs(item['endTime']).format('YYYY-MM-DD'),
    workspaceId: props.workSpace['id'],
  }).then(res=>{
    if(res.data.code == 1004){
      close();
      emit('submitCallback');
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};
const dataTypeChange = (target, input, value)=>{
  const list = [];
  if(value === 6){
    list.push(...inputListInitial, ...flyInputList);
    rules['trackType'] = [
      { required: true, message: '请选择目标', trigger: 'blur' },
    ]
    rules['classification'] = [
      { required: true, message: '请选择目标类型', trigger: 'blur' },
    ]
    rules['models'] = [
      { required: true, message: '请选择目标型号', trigger: 'blur' },
    ]
  }else{
    list.push(...inputListInitial);
    rules['trackType'] = undefined;
    rules['classification'] = undefined;
    rules['models'] = undefined;
  }
  inputList.value = list;
}
const inputListInitial = [
  { name: '数据名称', prop: 'dataName', type: 'text' },
  { name: '开始时间', prop: 'startTime', type: 'date', date: {}, },
  { name: '结束时间', prop: 'endTime', type: 'date', date: {}, },
  { name: '数据类型', prop: 'dataType', type: 'select',
    select: {
      list: 'dataTypeList',
      label: 'label',
      value: 'id',
      changeFun: dataTypeChange
    }
  },
],
flyInput = { name: '数据类型', prop: 'airTypeList', type: 'select',
  select: {
    list: 'airTypeListList',
    label: 'typeName',
    value: 'typeName',
    multiple: true,
  }
},
flyInputList = [
  { name: '目标', prop: 'trackType', type: 'select',
    select: {
      list: 'trackTypeList',
      label: 'name',
      value: 'type',
      changeFun: (target, input, value)=>{
        // console.log(target, input, value);
        for(const item of target[input['select']['list']]){
          if(item['type'] == value){
            target['classificationList'] = item['classification'];
            break;
          }
        }
      }
    }
  },
  { name: '目标类型', prop: 'classification', type: 'select',
    select: {
      list: 'classificationList',
      label: 'type',
      value: 'type',
      filterable: true,
      changeFun: (target, input, value)=>{
        // console.log(target, input, value);
        for(const item of target[input['select']['list']]){
          if(item['type'] == value){
            target['modelsList'] = item['models'];
            break;
          }
        }
      }
    }
  },
  { name: '目标型号', prop: 'models', type: 'select',
    select: {
      list: 'modelsList',
      value: 'this',
      filterable: true,
      multiple: true,
    }
  },
]


const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref(inputListInitial);
const rules = reactive({
  dataName: [
    { required: true, message: '请输入区域名称', trigger: 'blur' },
  ],
  startTime: [
    { required: true, message: '请选择开始时间', trigger: 'blur' },
  ],
  endTime: [
    { required: true, message: '请选择结束时间', trigger: 'blur' },
  ],
  dataType: [
    { required: true, message: '请选择数据类型', trigger: 'blur' },
  ],
});

const targetInit = ()=>{
  // target['trackTypeList'] = props.AirAndWarshipList;
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(async ()=>{
  targetInit();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>